const cast = (state={session:null},action)=>{
    switch(action.type){
        case "SET_CAST_SESSION":
            return Object.assign({},state,{session:action.payload})
        case "SET_CAST_PLAYING":
            return Object.assign({},state,{castPlaying:action.payload});
        default:
            return state;
    }
}

export default cast;


// WEBPACK FOOTER //
// ./src/reducers/cast.js